import React, { useState, useEffect, useRef } from "react";
import { API } from "aws-amplify";
import { useSelector, useDispatch } from "react-redux";
import User from "./AddUsersTenant.module.scss";
import { Close } from "@material-ui/icons";
import axios from "axios";
import config from "../../config/aws-exports";
import { Constants } from "../../config/constants";
import { authData } from "../../redux/auth/authSlice";
import { CircularProgress, Button } from "@material-ui/core";
import swal from "sweetalert";

const Hallticket = (props) => {
  let { handleClose, getUsers, rows, instructors } = props;

  const [loading, setLoading] = useState(true);
  const [open, setOpen] = useState(false);
  const [courseData, setCourseData] = useState();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [openFileUpload, setOpenFileUpload] = useState(false);
  const [selectedFile, setSelectedFile] = useState();
  const [pissueTextUpload, setPIssueTextUpload] = useState("");
  const [tempMfile, setTempMfile] = useState("");
  const [spin, setSpin] = useState(false);
  const [marksFile, setMarkFile] = useState();
  const [openCertificateFileUpload, setOpenCertificateFileUpload] =
    useState(false);
  const [fileSelected, setFileSelected] = useState(false);
  const [deleteMarksCert, setDeleteMarksCert] = useState(false);
  const [tempCfile, setTempCfile] = useState([]);
  const [openDelete, setOpenDelete] = useState(false);
  const [markLists, setMarkLists] = useState([]);
  const [sem, setSem] = useState("");
  const [fileuploadName, setFileuploadName] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [dateError, setDateError] = useState(""); // State for date validation error
  const dispatch = useDispatch();
  const componentRef = useRef();
  const userDetails = useSelector(authData);
  const today = new Date();
  const formatDate = (date) => {
    const year = date.getFullYear();
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    return `${year}-${month}-${day}`;
  };

  // Set min date to today for both inputs
  const minDate = formatDate(today);

  // Validate endDate is greater than startDate
  const validateDates = (start, end) => {
    if (start && end && new Date(end) <= new Date(start)) {
      setDateError("End date must be greater than start date");
      return false;
    }
    setDateError("");
    return true;
  };

  const changeHandlerHallticket = (e) => {
    setPIssueTextUpload("");
    setFileSelected(false);
    if (e.target.files !== undefined) {
      let selectedFile = e.target.files[0];
      let extend =
        selectedFile.name.substring(
          selectedFile.name.lastIndexOf(".") + 1,
          selectedFile.name.length
        ) || selectedFile.name;

      if (extend != "zip" || extend != "ZIP") {
        swal("Error", "Please upload zip files only", "error");
        setFileSelected(false);
        return;
      }

      let fileUploadType = "hallticketlist";
      let pfileName = new Date().getTime();
      let filename = pfileName + e.target.files[0].name;

      setFileuploadName(filename);
      setFileSelected(true);
      if (Array.isArray(tempCfile) && tempCfile.length > 0) {
        setTempMfile(e.target.files[0].name);
      } else {
        setTempMfile(e.target.files[0].name);
      }
      uploadDocsToServer(e.target.files[0], fileUploadType, filename);
    }
  };

  const uploadDocsToServer = async (file, fileUploadType, filename) => {
    setSpin(true);
    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        type: fileUploadType,
        filetype: file.type,
        filename: filename,
        folder: userDetails.curprgcou.bpid,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    try {
      let response = await API.post(
        config.aws_cloud_logic_custom_name,
        Constants.GET_PRESIGNED_URL,
        bodyParam
      );
      fileUpload(file, response, fileUploadType);
    } catch (error) {
      setLoading(false);
      console.error("getCategoryError", error);
    }
  };

  const fileUpload = async (file, url, fileUploadType) => {
    try {
      await axios.put(url, file, { headers: { "Content-Type": file.type } });
      setSpin(false);
    } catch (error) {
      console.error(error);
      setSpin(false);
    }
  };

  const onsubmit = async () => {
    if (!startDate || !endDate || !fileSelected) {
      swal({
        title: "Error",
        text: "Please select start date, end date, and upload a file",
        icon: "error",
        dangerMode: true,
      });
      return;
    }

    if (!validateDates(startDate, endDate)) {
      return;
    }

    setSpin(true);

    const bodyParam = {
      body: {
        oid: config.aws_org_id,
        bpid: userDetails.curprgcou.bpid,
        startDate: startDate,
        endDate: endDate,
        hallticket: fileuploadName,
      },
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
    };

    try {
      const response = await API.post(
        config.aws_cloud_logic_custom_name,
        "/uploadHallticket",
        bodyParam
      );
      setSpin(false);
      swal({
        title: "Success",
        text: "Uploaded successfully",
        icon: "success",
        dangerMode: true,
      }).then((willDelete) => {
        if (willDelete) {
          setSpin(false);
          handleClose();
        }
      });
    } catch (error) {
      console.error("getUserError", error);
      setSpin(false);

      swal({
        title: "Error",
        text: "Failed to upload hall ticket",
        icon: "error",
        dangerMode: true,
      });
    }
  };

  return (
    <div className={User.maincontainer}>
      <div className={User.iconcontainer}>
        <h3 className={User.create}>Hall Ticket</h3>
        <Close className={User.closebutton} onClick={handleClose} />
      </div>

      <div style={{ display: "flex", gap: "2rem", padding: "2rem" }}>
        <div style={{ display: "flex", gap: "1rem" }}>
          <h3>Start Date</h3>
          <input
            style={{
              paddingLeft: "5px",
              fontSize: "12px",
              border: "1px solid gray",
              borderRadius: "5px",
            }}
            type="date"
            onChange={(e) => {
              setStartDate(e.target.value);
              validateDates(e.target.value, endDate);
            }}
            value={startDate}
            min={minDate}
          />
        </div>
        <div style={{ display: "flex", gap: "1rem" }}>
          <h3>End Date</h3>
          <input
            style={{
              paddingLeft: "5px",
              fontSize: "12px",
              border: "1px solid gray",
              borderRadius: "5px",
            }}
            type="date"
            onChange={(e) => {
              setEndDate(e.target.value);
              validateDates(startDate, e.target.value);
            }}
            value={endDate}
            min={startDate || minDate}
          />
        </div>
      </div>

      {dateError && (
        <div
          style={{
            color: "#cc0000",
            marginBottom: "12px",
            textAlign: "start",
            fontSize: "13px",
          }}
        >
          <p>{dateError}</p>
        </div>
      )}

      <div className={User.form}>
        <div
          style={{
            color: "#cc0000",
            marginBottom: "12px",
            marginTop: "-10px",
            textAlign: "start",
            fontSize: "13px",
          }}
        >
          {/* <p>{fileErr}</p> */}
        </div>
        <div
          className={User.field}
          style={{
            border: "1px solid gray",
            padding: "50px",
            display: "block",
          }}
        >
          <input
            type="file"
            id="files"
            accept=".zip"
            onChange={(e) => changeHandlerHallticket(e)}
          />
        </div>

        <br />

        {spin ? (
          <CircularProgress />
        ) : (
          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              onsubmit();
            }}
            //disabled={!startDate || !endDate || !fileSelected || !!dateError || !window.navigator.onLine}
          >
            Save
          </Button>
        )}
      </div>
    </div>
  );
};

export default Hallticket;
